/**
 * How long something has been waiting — mono text, not a pill. The tone
 * escalates the colour (e.g. a question waiting a day reads red); the exact
 * time is in the title.
 */
import { clsx } from "clsx";

import type { PillTone } from "./Pill";
import { humanizeDuration, toneTextClass } from "../lib/aiTeam";

export function Age({
  seconds,
  tone = "muted",
  title,
  className,
}: {
  seconds: number;
  tone?: PillTone;
  title?: string;
  className?: string;
}) {
  return (
    <span className={clsx("font-mono text-xs shrink-0", toneTextClass(tone), className)} title={title}>
      {humanizeDuration(seconds)}
    </span>
  );
}
